import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import sharedStyles from "../../landing-feature-store-hub.module.css";
import styles from "./content-with-image-section.module.css";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
import { Heading } from "@cinch-labs/design-system";
export const ContentWithImageSection = ({ title , body , image  })=>{
    const { filename , alt  } = image;
    const imageUrl = getStoryblokImageServiceUrl(filename, {
        filters: [
            {
                quality: 70
            }
        ]
    });
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.sectionWrapper,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        className: sharedStyles.title,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("img", {
                src: imageUrl,
                alt: alt ? alt : "",
                className: styles.sectionImage
            })
        ]
    });
};
